var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"uk-overlay-default uk-position-cover uk-position-z-index uk-flex uk-flex-middle"},[_c('div',{class:_vm.type},_vm._l((_vm.elements),function(i){return _c('div')}),0)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26850f1c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/themes/frontend/uikit3/assets/js/theme-components/Loader.vue
// module id = sGna
// module chunks = 0